import React from "react";
import { FormattedMessage } from "react-intl";
import { get as _get } from "lodash";

const ReportHeader = ({ reportData }) => {
  const mainClient = _get(reportData, "client_name", "");
  const totalLeads = _get(reportData, "total_leads", "–");
  const totalCompanies = _get(reportData, "unique_companies", "–");
  const campaignName = _get(reportData, "campaign_name", "");

  return (
    <div className="sa-hero position-relative overflow-hidden">
      <div className="sa-hero__blob sa-hero__blob--pink" />
      <div className="sa-hero__blob sa-hero__blob--aqua" />

      <div className="container-fluid px-6">
        <div className="row g-5 align-items-center position-relative" style={{ zIndex: 1 }}>
          <div className="col-lg-6">
            <span className="sa-hero__label">
              <FormattedMessage
                id="strategic_analysis.view_report.hero.label"
                defaultMessage="Campaign Performance & Strategy"
              />
            </span>
            <h2 className="sa-hero__title">
              <FormattedMessage
                id="strategic_analysis.view_report.hero.title_line1"
                defaultMessage="Smarter Insight."
              />
              <br />
              <span>
                <FormattedMessage
                  id="strategic_analysis.view_report.hero.title_line2"
                  defaultMessage="Better Decisions."
                />
              </span>
            </h2>
            <p className="sa-hero__subtitle">
              <FormattedMessage
                id="strategic_analysis.view_report.hero.subtitle"
                defaultMessage="Strategic Analysis & Enablement Playbook"
              />
            </p>
            {mainClient && (
              <div className="d-flex flex-wrap gap-3">
                <span className="sa-hero__meta-pill">
                  <span className="sa-hero__meta-dot" />
                  <FormattedMessage
                    id="strategic_analysis.view_report.hero.client_label"
                    defaultMessage="Client: {client}"
                    values={{ client: mainClient }}
                  />
                </span>
                {campaignName && (
                  <span className="sa-hero__meta-pill">
                    <FormattedMessage
                      id="strategic_analysis.view_report.hero.campaign_label"
                      defaultMessage="Campaign: {campaign}"
                      values={{ campaign: campaignName }}
                    />
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="col-lg-6 d-none d-lg-block">
            <div className="sa-hero__stats-card">
              <h3 className="sa-hero__stats-title">
                <FormattedMessage
                  id="strategic_analysis.view_report.hero.outcomes_title"
                  defaultMessage="Campaign Outcomes"
                />
              </h3>
              <p className="sa-hero__stats-sub">
                <FormattedMessage
                  id="strategic_analysis.view_report.hero.outcomes_sub"
                  defaultMessage="Aggregate metrics across all channels"
                />
              </p>
              <div className="row g-4">
                <div className="col-6">
                  <p className="sa-hero__stat-label">
                    <FormattedMessage
                      id="strategic_analysis.view_report.hero.stat_leads"
                      defaultMessage="Total Leads (MQLs)"
                    />
                  </p>
                  <p className="sa-hero__stat-value sa-hero__stat-value--aqua">{totalLeads}</p>
                </div>
                <div className="col-6">
                  <p className="sa-hero__stat-label">
                    <FormattedMessage
                      id="strategic_analysis.view_report.hero.stat_companies"
                      defaultMessage="Unique Companies"
                    />
                  </p>
                  <p className="sa-hero__stat-value sa-hero__stat-value--pink">{totalCompanies}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
